import type {FC, ReactNode} from 'react';
import {memo} from 'react';

interface Props {
  allHeight?: boolean;
  children: ReactNode;
  firstColClassName?: string;
  secondColClassName?: string;
}

const TwoColumns: FC<Props> = ({
  allHeight = true,
  children,
  firstColClassName = '',
  secondColClassName = '',
}) => {
  return (
    <div className={`TwoColumnsLayouts ${allHeight ? 'percent100H' : ''}`}>
      <div className={firstColClassName} />
      <div className={`secondCol ${secondColClassName}`}>{children}</div>
    </div>
  );
};

export default memo(TwoColumns);
